var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilePersonalDataIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9C13.7762 9 14 8.77616 14 8.5C14 8.22384 13.7762 8 13.5 8C13.2238 8 13 8.22384 13 8.5C13 8.77616 13.2238 9 13.5 9Z",
    fill: "url(#paint0_linear_1276_3015)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9C17.7762 9 18 8.77616 18 8.5C18 8.22384 17.7762 8 17.5 8C17.2238 8 17 8.22384 17 8.5C17 8.77616 17.2238 9 17.5 9Z",
    fill: "url(#paint1_linear_1276_3015)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H17C17 11.5515 16.5515 12 16 12H14V13H16C17.103 13 18 12.103 18 11Z",
    fill: "url(#paint2_linear_1276_3015)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.134 19.043C24.3375 17.184 22.5915 15.9155 20.5765 15.732L18.399 15.534L18.1605 14.58C19.153 14.043 19.8575 13.0405 19.9805 11.867L21.229 11.451C22.2885 11.0975 23 10.11 23 8.99348C23 8.593 22.9055 8.19252 22.7265 7.835L22.5395 7.46152L22.731 6.88648C22.9095 6.35248 23 5.79548 23 5.232C23 2.347 20.653 0 17.768 0H13.2325C10.347 0 8 2.347 8 5.232C8 5.79548 8.09052 6.352 8.26852 6.88648L8.46 7.46152L8.27352 7.83452C8.09452 8.19252 8 8.593 8 8.99348C8 10.11 8.71148 11.0975 9.771 11.451L11.0195 11.8675C11.1425 13.041 11.847 14.0435 12.8395 14.5805L12.601 15.5345L10.423 15.7325C8.40852 15.916 6.66252 17.1845 5.866 19.0435L4.30848 22.678C4.104 23.1555 4 23.661 4 24.181C4 26.287 5.713 28 7.819 28H8V29.5C8 30.327 8.673 31 9.5 31H21.5C22.327 31 23 30.327 23 29.5V28H23.181C25.287 28 27 26.287 27 24.181C27 23.661 26.896 23.155 26.691 22.677L25.134 19.043ZM12.926 16.509L14.4885 17.134L13.6435 17.7675L12.89 16.512L12.926 16.509ZM18.074 16.509L18.1095 16.512L17.356 17.7675L16.511 17.134L18.074 16.509ZM9 8.99348C9 8.74748 9.058 8.502 9.168 8.28252L9.54 7.53848L9.21748 6.57052C9.073 6.138 9 5.688 9 5.232C9 2.8985 10.8985 1 13.232 1H17.7675C20.1015 1 22 2.8985 22 5.232C22 5.688 21.927 6.138 21.7825 6.57052L21.46 7.53848L21.832 8.28252C21.942 8.50148 22 8.74748 22 8.99348C22 9.679 21.563 10.285 20.9125 10.502L20 10.806V7.5C20 6.673 19.327 6 18.5 6H16C14.897 6 14 5.103 14 4H13C13 4.358 13.063 4.702 13.1785 5.02052C11.9515 5.17852 11 6.23052 11 7.5V10.806L10.087 10.5015C9.437 10.285 9 9.679 9 8.99348ZM12 11.5V7.5C12 6.673 12.673 6 13.5 6H13.766C14.3155 6.61352 15.1135 7 16 7H18.5C18.7755 7 19 7.22452 19 7.5V11.5C19 12.8785 17.8785 14 16.5 14H14.5C13.1215 14 12 12.8785 12 11.5ZM14.5 15H16.5C16.7455 15 16.985 14.974 17.216 14.926L17.409 15.698L15.5 16.4615L13.591 15.698L13.784 14.926C14.015 14.974 14.2545 15 14.5 15ZM19 27C18.4485 27 18 26.5515 18 26C18 25.4485 18.4485 25 19 25H21V27H19ZM20 24H19V21H19.5C19.7755 21 20 21.224 20 21.5V24ZM18 24.278C17.405 24.625 17 25.263 17 26H14C14 25.263 13.595 24.625 13 24.278V21H18V24.278ZM12 24H11V21.5C11 21.224 11.2245 21 11.5 21H12V24ZM12 25C12.5515 25 13 25.4485 13 26C13 26.5515 12.5515 27 12 27H10V25H12ZM22 29.5C22 29.776 21.7755 30 21.5 30H9.5C9.22448 30 9 29.776 9 29.5V28H12C12.737 28 13.375 27.595 13.722 27H17.2785C17.6255 27.595 18.2635 28 19.0005 28H22.0005V29.5H22ZM23.181 27H22V25H25V24H23V21H22V24H21V21.5C21 20.673 20.327 20 19.5 20H11.5C10.673 20 10 20.673 10 21.5V24H9V21H8V24H6V25H9V27H7.819C6.26452 27 5 25.7355 5 24.181C5 23.797 5.07652 23.4235 5.228 23.0705L6.78548 19.436C7.43752 17.9155 8.866 16.8775 10.5145 16.7275L11.785 16.612L13.357 19.232L15.5 17.625L17.6435 19.2325L19.2155 16.6125L20.4855 16.728C22.134 16.878 23.5625 17.916 24.2145 19.4365L25.772 23.071C25.9235 23.424 26 23.7975 26 24.181C26 25.7355 24.7355 27 23.181 27Z",
    fill: "url(#paint3_linear_1276_3015)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17H3V18H2V17Z",
    fill: "url(#paint4_linear_1276_3015)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17H1V18H0V17Z",
    fill: "url(#paint5_linear_1276_3015)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18H2V19H1V18Z",
    fill: "url(#paint6_linear_1276_3015)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16H2V17H1V16Z",
    fill: "url(#paint7_linear_1276_3015)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1H6V2H5V1Z",
    fill: "url(#paint8_linear_1276_3015)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H4V2H3V1Z",
    fill: "url(#paint9_linear_1276_3015)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H5V3H4V2Z",
    fill: "url(#paint10_linear_1276_3015)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0H5V1H4V0Z",
    fill: "url(#paint11_linear_1276_3015)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6C1.673 6 1 6.673 1 7.5C1 8.327 1.673 9 2.5 9C3.327 9 4 8.327 4 7.5C4 6.673 3.327 6 2.5 6ZM2.5 8C2.2245 8 2 7.77548 2 7.5C2 7.22448 2.2245 7 2.5 7C2.7755 7 3 7.22448 3 7.5C3 7.77548 2.7755 8 2.5 8Z",
    fill: "url(#paint12_linear_1276_3015)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H8V12H5V15ZM6 13H7V14H6V13Z",
    fill: "url(#paint13_linear_1276_3015)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17H29V18H28V17Z",
    fill: "url(#paint14_linear_1276_3015)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17H31V18H30V17Z",
    fill: "url(#paint15_linear_1276_3015)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18H30V19H29V18Z",
    fill: "url(#paint16_linear_1276_3015)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16H30V17H29V16Z",
    fill: "url(#paint17_linear_1276_3015)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H24V2H23V1Z",
    fill: "url(#paint18_linear_1276_3015)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25 1H26V2H25V1Z",
    fill: "url(#paint19_linear_1276_3015)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H25V3H24V2Z",
    fill: "url(#paint20_linear_1276_3015)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H25V1H24V0Z",
    fill: "url(#paint21_linear_1276_3015)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 7C30.327 7 31 6.327 31 5.5C31 4.673 30.327 4 29.5 4C28.673 4 28 4.673 28 5.5C28 6.327 28.673 7 29.5 7ZM29.5 5C29.7755 5 30 5.22448 30 5.5C30 5.77548 29.7755 6 29.5 6C29.2245 6 29 5.77548 29 5.5C29 5.22448 29.2245 5 29.5 5Z",
    fill: "url(#paint22_linear_1276_3015)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12H27V9H24V12ZM25 10H26V11H25V10Z",
    fill: "url(#paint23_linear_1276_3015)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1276_3015",
    x1: 26.4,
    y1: 33.9,
    x2: 26.4,
    y2: -2.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePersonalDataIcon);
export default __webpack_public_path__ + "static/media/profile_personal-data_icon.5a657e1a498d81db23f908c18c518fb5.svg";
export { ForwardRef as ReactComponent };